module.exports = __webpack_public_path__ + "img/parachute-octobre-6.53146696.jpg";